module.exports = __webpack_public_path__ + "static/media/martinez-alina.ca7411fe.png";